var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"country-badge",attrs:{"title":_vm.label}},[_c('i',{class:['country-flag', _vm.normalized],attrs:{"aria-hidden":"true"}},[(_vm.normalized === 'gh')?_c('b',[_vm._v("★")]):_vm._e()]),_c('span',[_vm._v(_vm._s(_vm.normalized.toUpperCase() || '—'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }